import { useSwrMutationApi } from 'src/hooks/useSwrApi/useSwrMutationApi';

type BestiePackType = 'BESTIE-SCREENING-START' | 'BESTIE-SCREENING-GROWTH' | 'BESTIE-SCREENING-SCALE';

interface UseSwrBestieScreeningActivateProps {
  onSuccess?: () => void | Promise<void>;
  onError?: (err: unknown) => void;
}

interface BestieScreeningActivatePayload {
  packType: BestiePackType;
}

export const useSwrBestieScreeningActivate = (props?: UseSwrBestieScreeningActivateProps) => {
  const { onSuccess, onError } = props ?? {};

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, BestieScreeningActivatePayload>({
    url: '/v1/bestie-screening/activate',
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: () => { if (onSuccess) { void onSuccess(); } },
      onError: (err) => { if (onError) onError(err); },
    },
    toastsOptions: {
      showErrorToast: true,
      showSuccessToast: false,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
